import React from 'react';
import { Typography } from '@material-ui/core';
import { getTemplateFriendlyType } from 'templates';

import styles from './TemplateContent.module.scss';

const TemplateContent = ({ data }) => {
  return (
    <div className={styles.templateContent}>
      <div
        className={styles.icon}
        style={data.icon ? { backgroundImage: `url(${data.icon})` } : undefined}
      />

      <div className={styles.info}>
        <Typography variant="button">
          {getTemplateFriendlyType(data.type) || ''}
        </Typography>
        <Typography variant="caption">{data.name || ''}</Typography>
        <Typography variant="subtitle1">{data.title || ''}</Typography>
      </div>
    </div>
  );
};

export default TemplateContent;
